import React, { memo } from 'react'
import { IconButton } from 'transfix-ui/components/IconButton'
import { ILoadBoardPost } from 'types/loadBoardPosts'
import { IShipment } from 'types/shipment'
import { DAT_FLAGS } from 'apps/booking/constants/loadBoardPosts'
import { EditIcon } from 'transfix-icons'
import { PostList } from './PostList'

interface ILoadBoardPostsProps {
  shipment?: IShipment
  posts: ILoadBoardPost[]
  openEditPosts: () => void
  editedString: string
  loading: boolean
  error: string
}

export const LoadBoardPosts = memo<ILoadBoardPostsProps>(
  ({ editedString, error, loading, openEditPosts, posts, shipment }) => {
    const flags = shipment?.flags || []
    const onLoadBoard = flags.find((f: string) => f === DAT_FLAGS.marketOnLoadBoards)

    return (
      <>
        <div className='row'>
          <div className='fl'>
            <div className='body-medium'>DAT posts for this shipment</div>
            <div className='text-caption-semibold'>{editedString}</div>
          </div>
          {posts.length > 0 && onLoadBoard && (
            <div className='fr'>
              <IconButton
                Icon={EditIcon}
                color='tertiary'
                onClick={openEditPosts}
                data-test='edit-post'
                label='Edit Post'
                size='large'
              />
            </div>
          )}
        </div>
        <div className='row mv4'>
          <PostList
            posts={posts}
            loading={loading}
            error={error}
            noPostMessage='There are no DAT posts for this shipment'
          />
        </div>
      </>
    )
  }
)
